import { routerReducer } from 'react-router-redux'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { combineEpics } from 'redux-observable'
import * as categories from './categories'
import * as contactRequests from './contactRequests'
import * as discounts from './discounts'
import * as importer from './importer'
import * as keywords from './keywords'
import * as media from './media'
import * as navigation from './navigation'
import * as carts from './carts'
import * as product from './product'
import * as properties from './properties'
import * as routes from './routes'
import * as tabs from './tabs'
import * as toDos from './toDos'
import * as user from './user'
import * as userAdmin from './userAdmin'

export const epic = combineEpics(
  ...Object.keys(carts)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => carts[epicName]),
  ...Object.keys(categories)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => categories[epicName]),
  ...Object.keys(contactRequests)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => contactRequests[epicName]),
  ...Object.keys(discounts)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => discounts[epicName]),
  ...Object.keys(importer)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => importer[epicName]),
  ...Object.keys(keywords)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => keywords[epicName]),
  ...Object.keys(media)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => media[epicName]),
  ...Object.keys(navigation)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => navigation[epicName]),
  ...Object.keys(product)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => product[epicName]),
  ...Object.keys(properties)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => properties[epicName]),
  ...Object.keys(routes)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => routes[epicName]),
  ...Object.keys(toDos)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => toDos[epicName]),
  ...Object.keys(user)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => user[epicName]),
  ...Object.keys(userAdmin)
    .filter((exportName) => exportName.match(/Epic$/))
    .map((epicName) => userAdmin[epicName])
)

export const reducer = combineReducers({
  carts: carts.cartReducer,
  categories: categories.categoriesReducer,
  contactRequests: contactRequests.contactRequestsReducer,
  discounts: discounts.discountsReducer,
  form: formReducer,
  importer: importer.importReducer,
  keywords: keywords.keywordReducer,
  media: media.mediaReducer,
  navigation: navigation.navigationReducer,
  product: product.productReducer,
  properties: properties.propertyReducer,
  routes: routes.routesReducer,
  router: routerReducer,
  tabs: tabs.tabsReducer,
  toDos: toDos.toDosReducer,
  user: user.userReducer,
  userAdmin: userAdmin.userAdminReducer,
})



// WEBPACK FOOTER //
// ./src/redux/app.js